<template>
  <div class="comp-md-krEditableMenuItem">
    <span class="item-line" v-if="index !== 0"></span>
    <div class="item-content" :class="{active: active}" @click="handleItem">
      <div class="item-operation-panel" :class="{main: index === 0}">
        <div class="item-operation-left-panel">
          <span class="item-operation-button item-move-left"  @click="handleIconButton('left')">
            <i class="icon iconfont icon-up item-operation-icon" :class="{disable: index === 1}"></i>
          </span>
          <span class="item-operation-button item-move-right" @click="handleIconButton('right')">
            <i class="icon iconfont icon-down item-operation-icon" :class="{disable: index === length - 1}"></i>
          </span>
        </div>
        <div class="item-operation-right-panel">
          <span class="item-operation-button item-delete">
            <i class="icon iconfont icon-garbage-active item-operation-icon" @click="handleIconButton('delete')"></i>
          </span>
        </div>
      </div>
      <!-- <span class="item-public item-title">{{metas.label}}</span>
      <span class="item-public item-listItem" :key="item.id" v-for="item in metas[childrenAttr]">
        <span class="item-listItem-title">{{item.label}}</span>
      </span> -->
      <el-menu
        class="el-menu-vertical">
        <el-menu-item :index="index + '1'">{{metas.label}}</el-menu-item>
        <span :key="index2 + '3'" v-for="item,index2 in metas[childrenAttr]">
          
          <!-- <el-menu-item :index="index + '2'" :key="item.id" v-for="item in metas[childrenAttr]">
            <span slot="title">{{item.label}}</span>
          </el-menu-item> -->

          <!-- 这里便是第三级菜单 -->
          <el-submenu :index="index + index2 + '3'" v-if="item.childMenuInfos && item.childMenuInfos.length > 0">
            <template slot="title">
              <span>{{item.label}}</span>
            </template>
            <span :index="index + index2 + childMenuIndex + '4-1'" :key="index + index2 + childMenuIndex + '4-1'" v-for="items,childMenuIndex in item.childMenuInfos">
               <!-- 这里便是第四级菜单 -->
              <el-submenu :index="index + index2 + childMenuIndex + '4-1-1'" v-if="items && items.childMenuInfos && items.childMenuInfos.length > 0">
                <template slot="title">
                  {{items.label ? items.label : ''}}
                </template>
                <el-menu-item :index="index + index2 + childMenuIndex + fourIndex + '4-2-1'" :key="index + index2 + childMenuIndex + fourIndex + '4-2-1'" v-for="fourItems, fourIndex in items.childMenuInfos">{{fourItems.label}}</el-menu-item>
              </el-submenu>

               <el-menu-item :index="index + index2 + childMenuIndex + '21'" v-else>
                <span slot="title">{{items.label ? items.label : ''}}</span>
              </el-menu-item>
            </span>
          </el-submenu>

          <el-menu-item :index="index + index2 + '2'" v-else>
            <span slot="title">{{item.label}}</span>
          </el-menu-item>
        </span>
      </el-menu>
    </div>
    <span class="item-line"></span>
    <span class="item-add">
      <i class="icon iconfont icon-add item-icon" @click="handleIconButton('add')"></i>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    metas: kr.vue.getPropObject(),
    index: kr.vue.getPropNumber(),
    length: kr.vue.getPropNumber(),
    active: kr.vue.getPropBoolean(),
    childrenAttr: kr.vue.getPropString('options')
  },
  methods: {
    handleItem() {
      // this.$emit('click', Object.assign({}, this.metas));
      this.$emit('click', this.metas);
    },
    handleIconButton(type) {
      const { index, length } = this;
      if ((index === 1 && type === 'left') || (index === length - 1 && type === 'right')) {
        return;
      }

      if (type === 'delete') {
        this.$confirm(`确认删除【${this.metas.label}】页签吗？删除后该页签指派的角色将按照默认页签显示`, '删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.$emit('handleIconButton', type, Object.assign({}, this.metas), index);
          kr.ui.success('删除页签成功！');
        }).catch(() => {
        });
      } else {
        this.$emit('handleIconButton', type, Object.assign({}, this.metas), index);
      }
    }
  }
}
</script>

<style lang="scss">
  .comp-md-krEditableMenuItem {
    display: inline-block;
    vertical-align: top;
    padding-top: 28px;

    .item-line {
      display: inline-block;
      width: 20px;
      height: 40px;
      height: 1px;
      background-color: #cacee0;
      margin: 20px 4px;
      vertical-align: top;
    }

    .item-add {
      display: inline-block;
      width: 30px;
      height: 30px;
      background: #f6f7fb;
      border-radius: 100%;
      margin-top: 5px;
      vertical-align: top;
      text-align: center;
      line-height: 30px;
      cursor: pointer;

      &:hover {
        .item-icon {
          color: $color-hover-primary;
        }
      }

      .item-icon {
        font-size: 20px;
        color: #9094a3;
      }
    }

    .active {
      border: 1px solid $color-primary !important;
      cursor: pointer !important;

      .item-title {
        color: #fff !important;
        background-color: $color-primary !important;
      }
    }

    .item-content {
      display: inline-block;
      border: 1px solid #e6e9f5;
      border-radius: 2px;
      .el-menu-vertical {
        .el-submenu span {
          margin-right: 15px
        }
      }
      /* box-sizing: border-box; */

      &:hover,
      &:active {
        border: 1px solid $color-hover-primary;
        cursor: pointer;

        .item-title {
          color: #fff;
          background-color: $color-hover-primary;
        }

        .item-operation-panel {
          display: block;
        }

        .main {
          display: none;
        }
      }

      &:active {
        border: 1px solid $color-primary;

        .item-title {
          background-color: $color-primary;
        }
      }

      &:active {
        border: 1px solid $color-primary;

        .item-title {
          background-color: $color-primary;
        }
      }

      .item-operation-panel {
        height: 28px;
        margin-top: -28px;
        display: none;

        .item-operation-icon {
          display: inline-block;
          overflow: hidden;
          line-height: 20px;
          padding: 0 !important;
          padding-top: 1px !important;
          height: 20px !important;
          color: #9094a3;
          text-align: center;

          &:hover {
            color: $color-hover-primary;
          }
        }

        .item-operation-button {
          display: inline-block;
          width: 20px;
          line-height: 20px;
          height: 20px;
          background: #f6f7fb;
          border-radius: 2px;
        }

        .item-operation-button::before {
          margin-top: 1px;
        }

        .item-operation-left-panel {
          float: left;

          .disable {
            color: #cacee0;
          }

          .item-move-left {
            margin-left: -1px;
            margin-right: 10px;
            transform: rotate(-90deg);
          }

          .item-move-right {
            transform: rotate(-90deg);
          }
        }

        .item-operation-right-panel {
          float: right;

          .item-delete {
            margin-right: -1px;
          }
        }
      }

      .item-public {
        display: block;
        padding: 8px 20px;
        min-width: 76px;
      }

      .item-title {
        font-size: 16px;
        font-weight: 500;
        color: #2e3242;
        background: #f6f7fb;
        line-height: 24px;
      }

      .item-listItem {
        font-size: 14px;
        color: #525975;
        text-align: left;
        height: 38px;
        line-height: 22px;
        background-color: #fff;
        padding: 0;

        &:hover {
          background: #f6f7fb;
          border-radius: 2px;
        }

        .item-listItem-title {
          padding: 8px 20px;
          display: block;
        }
      }
    }
  }
</style>